import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { from, switchMap } from 'rxjs';
import { environment } from '../../environments/environment';
import { AuthTokenService } from './auth-token.service';

export const bearerTokenInterceptor: HttpInterceptorFn = (req, next) => {
  if (!isApiRequest(req.url)) {
    return next(req);
  }

  const authTokenService = inject(AuthTokenService);
  return from(authTokenService.acquireAccessToken()).pipe(
    switchMap((token) => {
      if (!token) {
        return next(req);
      }

      return next(
        req.clone({
          setHeaders: {
            Authorization: `Bearer ${token}`
          }
        })
      );
    })
  );
};

function isApiRequest(url: string): boolean {
  if (url.startsWith('/api/')) {
    return true;
  }

  const baseUrl = environment.apiUrl?.toLowerCase() ?? '';
  if (baseUrl.startsWith('http')) {
    return url.toLowerCase().startsWith(baseUrl);
  }

  return false;
}
